const getNextPageInFlowSubaru = (modelData, language) => {
  const hasSingleModelType = modelData.length === 1
  const { brand, model, year } = modelData?.[0] || {}
  const query = { brand, model, year, modelType: '', language }
  const result = {
    page: 'modelTypes',
    query,
    error: null
  }
  if (hasSingleModelType) {
    result.page = 'publications'
    result.query.modelType = modelData[0].modelType
  }
  return result
}

export default getNextPageInFlowSubaru
